import { useState } from "react";
import { GripVertical, ChevronUp, ChevronDown } from "lucide-react";

export const moveItem = (arr, from, to) => {
  if (to < 0 || to >= arr.length || from === to) return arr;
  const next = [...arr];
  const [m] = next.splice(from, 1);
  next.splice(to, 0, m);
  return next;
};

const ctrlBtn =
  "p-1.5 text-black/45 hover:text-black hover:bg-black/5 disabled:opacity-25 disabled:hover:bg-transparent transition-colors";

const Controls = ({ i, count, onMove, onArm, testid }) => (
  <div className="inline-flex items-center gap-0.5" data-testid={`${testid}-controls-${i}`}>
    <span
      onMouseDown={() => onArm(i)}
      onMouseUp={() => onArm(null)}
      className="p-1.5 text-black/45 hover:text-black cursor-grab active:cursor-grabbing"
      title="Drag to reorder"
      data-testid={`${testid}-drag-${i}`}
    >
      <GripVertical size={16} />
    </span>
    <button type="button" onClick={() => onMove(i, i - 1)} disabled={i === 0} className={ctrlBtn} title="Move up" data-testid={`${testid}-up-${i}`}>
      <ChevronUp size={16} />
    </button>
    <button type="button" onClick={() => onMove(i, i + 1)} disabled={i === count - 1} className={ctrlBtn} title="Move down" data-testid={`${testid}-down-${i}`}>
      <ChevronDown size={16} />
    </button>
  </div>
);

export const SortableList = ({ items, onChange, renderItem, getKey, itemClassName = "", testid }) => {
  const [armed, setArmed] = useState(null);
  const [dragIdx, setDragIdx] = useState(null);
  const [overIdx, setOverIdx] = useState(null);
  const onMove = (from, to) => onChange(moveItem(items, from, to));
  const reset = () => { setArmed(null); setDragIdx(null); setOverIdx(null); };

  return (items || []).map((item, i) => (
    <div
      key={getKey ? getKey(item, i) : i}
      draggable={armed === i}
      onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; setDragIdx(i); }}
      onDragOver={(e) => { if (dragIdx === null) return; e.preventDefault(); if (overIdx !== i) setOverIdx(i); }}
      onDrop={(e) => { e.preventDefault(); if (dragIdx !== null) onMove(dragIdx, i); reset(); }}
      onDragEnd={reset}
      className={`${itemClassName} transition-[opacity,box-shadow] duration-150 ${dragIdx === i ? "opacity-40" : ""} ${
        overIdx === i && dragIdx !== null && dragIdx !== i
          ? dragIdx > i ? "shadow-[0_-3px_0_0_var(--accent)]" : "shadow-[0_3px_0_0_var(--accent)]"
          : ""
      }`}
      data-testid={`${testid}-item-${i}`}
    >
      {renderItem(item, i, <Controls i={i} count={items.length} onMove={onMove} onArm={setArmed} testid={testid} />)}
    </div>
  ));
};
